import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormDatosSacramentalesHermana extends Component {
  constructor(props) {
    super(props);
    this.DatosSacramentalesPut = this.DatosSacramentalesPut.bind(this);
  }

  // Función que hace un put de los datos sacramentales de la monja
  DatosSacramentalesPut(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/datosSacramentos",
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito los asigna al estado del componente monja detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setDatosHermana(response);
      })
      .fail($this[0].props.ErrorHandling);
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();

    // Default value lo establece del props de datos monja pasado en hermana detalles
    return (
      <Form className=" p-4" onSubmit={this.DatosSacramentalesPut} autoComplete="off" id="MyForm">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Fecha Bautismo *</Form.Label>
          <Form.Control required max={today} type="date" name="baptism" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.baptism} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Lugar de Bautismo *</Form.Label>
          <Form.Control required type="text" name="baptismPlace" maxLength="90" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.baptismPlace} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Diócesis</Form.Label>
          <Form.Control type="text" name="diocese" maxLength="60" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.diocese} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Fecha de confirmación</Form.Label>
          <Form.Control type="date" name="confirmation" max={today} autoComplete="nope" defaultValue={this.props.DatosMonja.sister.confirmation} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Lugar de Confirmación</Form.Label>
          <Form.Control type="text" name="confirmationPlace" maxLength="90" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.confirmationPlace} />
        </Form.Group>
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            name="Datos Sacramentales"
          //onClick={this.props.handleButtonShow} TODO
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
